import { PartnerTile } from "./partnerTile";
import { SponsorPromotionTile } from "./sponsorPromotionTile";

import ownlogo from '../images/logos/hard_adv_slogan.webp';
import partnerADVAcademy from '../images/logos/ADV-Academy.png';
import partnerADVDealers from '../images/logos/ATV-Dealers.png';
//import partnerAdventureBikesCoNZ from '../images/logos/adv-bikes-co-nz.jpg';
import partnerAGGraphics from '../images/logos/AGGraphics.png';
import partnerB2Bike from '../images/logos/B2Bike.png';
import partnerBMWMottorrad from '../images/logos/BMW_Mottorrad.png';
//import partnerBrowarGlubczyce from '../images/logos/browar-glubczyce.jpg';
//import partnerCamelAdv from '../images/logos/camel-adv.png';
//import partnerCardo from '../images/logos/cardo.png';
import partnerCARPE_Iter from '../images/logos/CARPE_Iter.png';
import partnerChampion from '../images/logos/Champion.png';
//import partnerDavca from '../images/logos/davca.png';
import partnerDefender from '../images/logos/defender.png';
//import partnerDominator from '../images/logos/dominator.png';
import partnerDNA_HP from '../images/logos/DNA_HP.png';
import partnerDobresklepy from '../images/logos/dobresklepy.png';
//import partnerDopeMirrors from '../images/logos/dope-mirrors.png';
import partnerDunlop from '../images/logos/dunlop.png';
//import partnerDzikaBryka from '../images/logos/dzika-bryka.png';
import partnerEmpro from '../images/logos/empro.png';
//import partnerEnduristanUbezpieczenia from '../images/logos/enduristan-ubezpieczenia.jpg';
//import partnerFox from '../images/logos/fox.png';
//import partnerGarmin from '../images/logos/garmin.png';
//import partnerGarda from '../images/logos/garda.png';
import partnerGMoto from '../images/logos/gmoto.png';
import partnerHeed from '../images/logos/heed.jpg';
//import partnerHondaKarlik from '../images/logos/honda-karlik.png';
import partnerKOVE from '../images/logos/KOVE.png';
import partnerKriega from '../images/logos/kriega.png';
//import partnerKtmSklep from '../images/logos/ktm-sklep.jpg';
import partnerLeatt from '../images/logos/leatt.png';
import partnerLibertyMotors from '../images/logos/liberty-motors.png';
import partnerLoneRider from '../images/logos/lone-rider.jpg';
import partnerMediahouse from '../images/logos/mediahouse.png';
import partnerMiastoZywiec from '../images/logos/miasto-zywiec.png';
import partnerMFsQUAD from '../images/logos/MF-sQUAD.png';
//import partnerMitas from '../images/logos/mitas.png';
import partnerMiwa from '../images/logos/Miwa-trans.png';
import partnerMotozet from '../images/logos/Motozet.png';
import partnerMountreme from '../images/logos/mountreme.png';
//import partnerMotoMyczki from '../images/logos/moto-myczki-team.png';
import partnerMucOff from '../images/logos/muc-off.png';
//import partnerNGK from '../images/logos/ngk.png';
import partnerNexxHelmets from '../images/logos/nexx-helmets.png';
//import partnerNTK from '../images/logos/ntk.png';
import partnerOffroad from '../images/logos/OffroadAdventureTrips.png';
import partnerOMoto from '../images/logos/o-moto.png';
//import partnerOdinsberg from '../images/logos/odinsberg.png';
import partnerOlekMotocykle from '../images/logos/olek-motocykle.png';
//import partnerOneEleven from '../images/logos/one-eleven.jpg';
import partnerPoligrafiks from '../images/logos/poligrafiks.png';
import partnerPolaris from '../images/logos/polaris.png';
//import partnerPoloptic from '../images/logos/poloptic.png';
//import partnerPrzystanekSycylia from '../images/logos/przystanek-sycylia.jpg';
import partnerQuadLock from '../images/logos/quad-lock.png';
import partnerRadeGarage from '../images/logos/rade-garage.png';
import partnerRanchoAdama from '../images/logos/rancho-adama.png';
//import partnerRats from '../images/logos/rats.png';
import partnerRebelhorn from '../images/logos/rebelhorn.png';
//import partnerRedMamut from '../images/logos/red-mamut.png';
//import partnerRedline from '../images/logos/redline.png';
//import partnerRepsol from '../images/logos/repsol.png';
import partnerRevit from '../images/logos/revit.png';
import partnerRaceduck from '../images/logos/raceduck.jpg';
//import partnerStecSuspension from '../images/logos/stec-suspension.png';
import partnerTouratechPolska from '../images/logos/touratech-polska.png';
//import partnerXrepo from '../images/logos/xrepo.png';
import partnerYakkExp from '../images/logos/yakk-exp.png';
//import partnerYamaha from '../images/logos/yamaha.png';

export interface IPartnerSectionProps {
    customClassName?: string;
}

export const PartnerSection = (props: IPartnerSectionProps) => {
    const {customClassName} = props;

    return <div className={`partner-tile__grid-wrapper ${customClassName}`}>
        <PartnerTile imgSrc={partnerADVAcademy} imgAlt={'ADV Academy'} title={'ADV Academy'} />
        <PartnerTile imgSrc={partnerADVDealers} imgAlt={'ATV Dealers'} title={'ATV Dealers'} />
        <PartnerTile imgSrc={partnerAGGraphics} imgAlt={'AG Graphics'} title={'AG Graphics'} />
        <PartnerTile imgSrc={partnerB2Bike} imgAlt={'B2Bike'} title={'B2Bike'} />
        <PartnerTile imgSrc={partnerBMWMottorrad} imgAlt={'BMW Motorrad'} title={'BMW Motorrad'} />
        <PartnerTile imgSrc={partnerCARPE_Iter} imgAlt={'CARPE Iter'} title={'CARPE Iter'} />
        <PartnerTile imgSrc={partnerChampion} imgAlt={'Champion'} title={'Champion'} />
        <PartnerTile imgSrc={partnerDNA_HP} imgAlt={'DNA HP'} title={'DNA HP'} />
        <PartnerTile imgSrc={partnerDefender} imgAlt={'Defender Akcesoria Motocyklowe'} title={'Defender Akcesoria Motocyklowe'} customClassName='partner-tile__img--medium' />
        <PartnerTile imgSrc={partnerDobresklepy} imgAlt={'Dobresklepy'} title={'Dobresklepy'} />
        <PartnerTile imgSrc={partnerDunlop} imgAlt={'Dunlop'} title={'Dunlop'} />
        <PartnerTile imgSrc={partnerEmpro} imgAlt={'Empro'} title={'Empro'} />
        <PartnerTile imgSrc={partnerGMoto} imgAlt={'Gmoto'} title={'Gmoto'} customClassName='partner-tile__img--medium' />
        <PartnerTile imgSrc={partnerHeed} imgAlt={'Heed'} title={'Heed'} />
        <PartnerTile imgSrc={partnerKOVE} imgAlt={'Kove Bielsko'} title={'Kove Bielsko'} />
        <PartnerTile imgSrc={partnerKriega} imgAlt={'Kriega'} title={'Kriega'} />
        <PartnerTile imgSrc={partnerLeatt} imgAlt={'Leatt'} title={'Leatt'} />
        <PartnerTile imgSrc={partnerLibertyMotors} imgAlt={'Liberty'} title={'Liberty'} />
      <PartnerTile imgSrc={partnerLoneRider} imgAlt={'Lone Rider'} title={'Lone Rider'} customClassName='partner-tile__img--medium' />
      <SponsorPromotionTile
          imgSrc={ownlogo}
          imgAlt="Hard ADV Slogan"
      />
        <PartnerTile imgSrc={partnerMFsQUAD} imgAlt={'MF sQUAD'} title={'MF sQUAD'} />
        <PartnerTile imgSrc={partnerMediahouse} imgAlt={'MediaHouse'} title={'MediaHouse'} />
        <PartnerTile imgSrc={partnerMiastoZywiec} imgAlt={'Miasto Żywiec'} title={'Miasto Żywiec'} />
        <PartnerTile imgSrc={partnerMiwa} imgAlt={'Miwa Trans'} title={'Miwa Trans'} />
        <PartnerTile imgSrc={partnerMotozet} imgAlt={'Motozet'} title={'Motozet'} />
        <PartnerTile imgSrc={partnerMountreme} imgAlt={'Monutreme.pl'} title={'Monutreme.pl'} customClassName='partner-tile__img--wide' />
        <PartnerTile imgSrc={partnerMucOff} imgAlt={'Muc-Off'} title={'Muc-Off'} />
        <PartnerTile imgSrc={partnerNexxHelmets} imgAlt={'Nexx Helmets'} title={'Nexx Helmets'} customClassName='partner-tile__img--wide' />
        <PartnerTile imgSrc={partnerOffroad} imgAlt={'Offroad Adventure Trips'} title={'Offroad Adventure Trips'} />
        <PartnerTile imgSrc={partnerOMoto} imgAlt={'O-Moto'} title={'O-Moto'} />
        <PartnerTile imgSrc={partnerOlekMotocykle} imgAlt={'Olek Motocykle'} title={'Olek Motocykle'} customClassName='partner-tile__img--medium' />
        <PartnerTile imgSrc={partnerPoligrafiks} imgAlt={'Poligrafiks'} title={'Poligrafiks'} customClassName='partner-tile__img--wide' />
        <PartnerTile imgSrc={partnerPolaris} imgAlt={'Polaris'} title={'Polaris'} />
        <PartnerTile imgSrc={partnerQuadLock} imgAlt={'Quad Lock'} title={'Quad Lock'} />
        <PartnerTile imgSrc={partnerRadeGarage} imgAlt={'Rade Garage'} title={'Rade Garage'} customClassName='partner-tile__img--medium' />
        <PartnerTile imgSrc={partnerRaceduck} imgAlt={'Raceduck'} title={'Raceduck'} />
        <PartnerTile imgSrc={partnerRanchoAdama} imgAlt={'RANCHO ADAMA'} title={'RANCHO ADAMA'} />
        <PartnerTile imgSrc={partnerRebelhorn} imgAlt={'RebelHorn'} title={'RebelHorn'} />
        <PartnerTile imgSrc={partnerRevit} imgAlt={'Revit'} title={'Revit'} customClassName='partner-tile__img--medium' />
        <PartnerTile imgSrc={partnerTouratechPolska} imgAlt={'Touratech'} title={'Touratech'} />
        <PartnerTile imgSrc={partnerYakkExp} imgAlt={'Yakk'} title={'Yakk'} />
        {/* <PartnerTile imgSrc={partnerAdventureBikesCoNZ} imgAlt={'ADVENTURE BIKES COMPANY NEW ZEALAND'} title={'ADVENTURE BIKES COMPANY NEW ZEALAND'} /> */}
        {/* <PartnerTile imgSrc={partnerBrowarGlubczyce} imgAlt={'BROWAR GŁUBCZYCE'} title={'BROWAR GŁUBCZYCE'} /> */}
        {/* <PartnerTile imgSrc={partnerCamelAdv} imgAlt={'CAMEL ADV'} title={'CAMEL ADV'} /> */}
        {/* <PartnerTile imgSrc={partnerCardo} imgAlt={'CARDO'} title={'CARDO'} /> */}
        {/* <PartnerTile imgSrc={partnerDavca} imgAlt={'DAVCA'} title={'DAVCA'} /> */}
        {/* <PartnerTile imgSrc={partnerDominator} imgAlt={'DOMINATOR'} title={'DOMINATOR'} /> */}
        {/* <PartnerTile imgSrc={partnerDopeMirrors} imgAlt={'DOPE MIRRORS'} title={'DOPE MIRRORS'} /> */}
        {/* <PartnerTile imgSrc={partnerDzikaBryka} imgAlt={'DZIKA BRYKA'} title={'DZIKA BRYKA'} /> */}
        {/* <PartnerTile imgSrc={partnerEnduristanUbezpieczenia} imgAlt={'ENDURISTAN UBEZPIECZENIA'} title={'ENDURISTAN UBEZPIECZENIA'} /> */}
        {/* <PartnerTile imgSrc={partnerFox} imgAlt={'FOX'} title={'FOX'} /> */}
        {/* <PartnerTile imgSrc={partnerGarda} imgAlt={'GARDA'} title={'GARDA'} /> */}
        {/* <PartnerTile imgSrc={partnerGarmin} imgAlt={'GARMIN'} title={'GARMIN'} /> */}
        {/* <PartnerTile imgSrc={partnerHondaKarlik} imgAlt={'HONDA KARLIK'} title={'HONDA KARLIK'} customClassName='partner-tile__img--wide' /> */}
        {/* <PartnerTile imgSrc={partnerKtmSklep} imgAlt={'KTM SKLEP'} title={'KTM SKLEP'} /> */}
        {/* <PartnerTile imgSrc={partnerMitas} imgAlt={'MITAS'} title={'MITAS'} /> */}
        {/* <PartnerTile imgSrc={partnerMotoMyczki} imgAlt={'MOTO MYCZKI TEAM'} title={'MOTO MYCZKI TEAM'} /> */}
        {/* <PartnerTile imgSrc={partnerNGK} imgAlt={'NGK'} title={'NGK'} /> */}
        {/* <PartnerTile imgSrc={partnerNTK} imgAlt={'NTK'} title={'NTK'} /> */}
        {/* <PartnerTile imgSrc={partnerOdinsberg} imgAlt={'ODINSBERG'} title={'ODINSBERG'} /> */}
        {/* <PartnerTile imgSrc={partnerOneEleven} imgAlt={'ONE ELEVEN'} title={'ONE ELEVEN'} /> */}
        {/* <PartnerTile imgSrc={partnerPoloptic} imgAlt={'POLOPTIC SALONY OPTYCZNE'} title={'POLOPTIC SALONY OPTYCZNE'} /> */}
        {/* <PartnerTile imgSrc={partnerPrzystanekSycylia} imgAlt={'PRZYSTANEK SYCYLIA'} title={'PRZYSTANEK SYCYLIA'} customClassName='partner-tile__img--medium' /> */}

        {/* <PartnerTile imgSrc={partnerRats} imgAlt={'RATs'} title={'REGIONAL ADVENTURE TRAILS'} /> */}
        {/* <PartnerTile imgSrc={partnerRedMamut} imgAlt={'RED MAMUT'} title={'RED MAMUT'} /> */}
        {/* <PartnerTile imgSrc={partnerRedline} imgAlt={'REDLINE'} title={'REDLINE'} customClassName='partner-tile__img--medium' /> */}
        {/* <PartnerTile imgSrc={partnerRepsol} imgAlt={'REPSOL'} title={'REPSOL'} /> */}
        {/* <PartnerTile imgSrc={partnerStecSuspension} imgAlt={'STEC SUSPENSION'} title={'STEC SUSPENSION'} /> */}
        {/* <PartnerTile imgSrc={partnerXrepo} imgAlt={'XREPO'} title={'XREPO'} /> */}
        {/* <PartnerTile imgSrc={partnerYamaha} imgAlt={'YAMAHA'} title={'YAMAHA'} customClassName='partner-tile__img--medium' /> */}
    </div>;
}
